var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"py-8 pl-4"},[_c('sharing-qr-code')],1)}
var staticRenderFns = []

export { render, staticRenderFns }